import { isDefined } from '@sgme/fp';
import type { DealSplitData, DealSplitIndependentAmount } from 'models/forms/DealSplitData';
import { isDealSplitGridMetadata } from 'models/forms/fields/DealSplitGridMetadata';

import { asGridRows, createGridCellExtractor } from '../gridExtractor';

const CUSTODIAN_COLUMN_ID = 'Custodian';
const NOTIONAL_COLUMN_ID = 'NotionalAmountInGrid';
const IA_MAIN_COLUMN_ID = 'IndependentAmount';
const IA_VALUE_DATE_COLUMN_ID = 'IndependentAmountValueDate';

function hasIndependentAmountColumn(rows: readonly DealSplitData[]): boolean {
  return rows.some(row => row?.IndependentAmount !== null && row?.IndependentAmount !== undefined);
}

function hasIndependentAmountValues(independentAmount?: DealSplitIndependentAmount): boolean {
  return (
    isDefined(independentAmount) &&
    (isDefined(independentAmount?.Type) ||
      isDefined(independentAmount?.Value) ||
      isDefined(independentAmount?.ValueDate))
  );
}

function normalizeIndependentAmountMain(independentAmount?: DealSplitIndependentAmount) {
  return {
    isEnabled: isDefined(independentAmount),
    type: independentAmount?.Type,
    value: independentAmount?.Value,
  };
}

export const dealSplitGridCellExtractor = createGridCellExtractor({
  isHandled: isDealSplitGridMetadata,
  getRows: asGridRows<DealSplitData>,
  getColumns: (_meta, previousRows, currentRows) => {
    const hasIAColumn = hasIndependentAmountColumn(previousRows) || hasIndependentAmountColumn(currentRows);

    return [
      {
        id: CUSTODIAN_COLUMN_ID,
        includeOnRowChange: true,
        getValue: row => row?.Custodian,
      },
      {
        id: NOTIONAL_COLUMN_ID,
        includeOnRowChange: true,
        getValue: row => row?.NotionalAmountInGrid,
      },
      {
        id: IA_MAIN_COLUMN_ID,
        isVisible: () => hasIAColumn,
        includeOnRowChange: true,
        getValue: row => normalizeIndependentAmountMain(row?.IndependentAmount),
      },
      {
        id: IA_VALUE_DATE_COLUMN_ID,
        isVisible: row => hasIndependentAmountValues(row?.IndependentAmount),
        includeOnRowChange: true,
        getValue: row => row?.IndependentAmount?.ValueDate,
      },
    ];
  },
});
